import Status from 'clarks/components/ivu-table/status'
let exports = {
   select_date: {
      forms: [
         { type: 'text', form_type: 'text', class: 'col-12', model: 'format', validation: 'required|min:2|max:50', label: 'Format', placeholder: 'e.g. DD/MM/YYYY'},
         { type: 'select', class: 'col-12 col-md-6', model: 'time', validation: '', options: [], label: 'Time Field', filterable: true, clearable: true},
         { type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'time_format', validation: 'min:2|max:50', label: 'Time Format', placeholder: 'e.g. HH:mm:SS'},
      ],
   }
}

let forms = {
   addField: {
      icon: 'fa fa-university',
      title: 'Add Field',
      subtitle: 'Provide Field Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "min:3|max:100", model: "alias", label: "Alias", },
         {
            type: 'form-select', class: 'col-12', model: 'type', clearable: true,
            options: [
               { val: "STRING", label: "String", },
               { val: "DATE", label: "Date", forms: exports.select_date.forms },
               { val: "NUMBER", label: "Number", },
               { val: "SELECT", label: "Select", },
               { val: "LATITUDE", label: "Latitude", },
               { val: "LONGITUDE", label: "Longitude", },
               { val: "REGION", label: "Region", },
               { val: "BOOLEAN", label: "Boolean", },
            ], validation: 'required', label: 'Field Type'
         },
         { type: "checkbox", class: "col-12 custom-check", validation: "", model: "nullable", label: "Is Nullable", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '3', validation: 'min:10|max:500', label: 'Description'},
      ]
   },
   addFieldFaker: {
      icon: 'fa fa-university',
      title: 'Add Field',
      subtitle: 'Provide Field Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "min:3|max:100", model: "alias", label: "Alias", },
         {
            type: 'form-select', class: 'col-12', model: 'type', clearable: true,
            options: [
               { val: "STRING", label: "String", },
               { val: "DATE", label: "Date", forms: exports.select_date.forms },
               { val: "NUMBER", label: "Number", },
               { val: "SELECT", label: "Select", },
               { val: "LATITUDE", label: "Latitude", },
               { val: "LONGITUDE", label: "Longitude", },   
               { val: "REGION", label: "Region", },
               { val: "BOOLEAN", label: "Boolean", },
            ], validation: 'required', label: 'Field Type'
         },
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:5000", model: "faker", label: "Faker Option", },
         { type: "checkbox", class: "col-12 custom-check", validation: "", model: "nullable", label: "Is Nullable", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '3', validation: 'min:10|max:500', label: 'Description'},
      ]
   },
   editField: {
      icon: 'fa fa-university',
      title: 'Edit Field',
      subtitle: 'Update Field Details',
      forms: [
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_accessible", label: "Is Accessible", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "alias", label: "Alias", },
         {
            type: 'form-select', class: 'col-12 col-md-6', model: 'type', clearable: true,
            options: [
               { val: "STRING", label: "String", },
               { val: "DATE", label: "Date", forms: exports.select_date.forms },
               { val: "NUMBER", label: "Number", },
               { val: "SELECT", label: "Select", },
               { val: "LATITUDE", label: "Latitude", },
               { val: "LONGITUDE", label: "Longitude", },
               { val: "REGION", label: "Region", },
               { val: "BOOLEAN", label: "Boolean", },
            ], validation: '', label: 'Field Type'
         },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '3', validation: 'min:10|max:500', label: 'Description'},
      ]
   },
   link_table: {
      icon: 'fa fa-link',
      title: 'Link Table',
      subtitle: 'Add a link to another table',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'table', clearable: true,
            options: [], validation: '', label: 'Table'
         },
         {
            type: 'select', class: 'col-12', model: 'foreign_field', clearable: true,
            options: [], validation: '', label: 'Foreign Field'
         },
      ]
   },
}

let tables = {
   field: {
      props: {
         icon: 'fa fa-database',
         title: 'Fields',
         border: true,
         'max-height': 600,
         'show-summary': false,
         search_fields: ['alias', 'type', 'name' ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Name", key: "name", },
            { title: "Alias", key: "alias", },
            { title: "Link", slot: "link", align: 'center' },
            { title: "Database Type", slot: "data_type", align: 'center',},
            { title: "Record Type", key: "type", align: 'center',},
            { title: "Last Update", slot: "date", align: 'center', width: 150 },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'field:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Link Table', event: 'field:link_table', icon: 'fa-link', allow_multiple: false },
            { type: 'menu', title: 'Unlink Table', event: 'field:unlink_table', icon: 'fa-unlink', allow_multiple: true },
            { type: 'menu', title: 'Delete', event: 'field:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: {...utils.generateAllFormData(forms),...utils.generateAllFormData(exports)},
   tables
}